import { useLang } from 'hooks/lang';

import { recruitmentStatusConfig, actions } from 'entities';

import { Alert, Button, Column } from 'components/Blocks';

import { DoubleCheckIcon } from 'components/Icons';

import { useSingleConfirmation } from 'providers/Confirmation';
import { useRecruitmentModal } from './context';

export function FinishRecruitment() {
  const { t } = useLang();
  const { recruitment, updateRecruitment, setTab, permissions } = useRecruitmentModal();

  const finishRecruitment = actions.projects.finishRecruitment.use({
    block: !permissions.canFinish,

    params: {
      recruitmentId: recruitment!.id,
    },

    onSuccess: () => {
      updateRecruitment({
        ...recruitment!,
        status: recruitmentStatusConfig.done.code,
      });

      setTab('main');
    },
  });

  const requestFinish = useSingleConfirmation({
    onConfirm: finishRecruitment.onClick,

    type: 'irreversible',
  });

  return (
    <Column>
      {recruitment!.sampleRecruitmentId ? (
        <Alert title={t('sample-connection')} level="info">
          {t('finishing-recruitment-sample')}
        </Alert>
      ) : (
        <Alert title={t('recruitment-not-on-sample')}>
          {t('recruitment-not-sample-explanation')}
        </Alert>
      )}

      <Button
        onClick={requestFinish}
        loading={finishRecruitment.loading}
        disabled={!permissions.canFinish}
        variant="outlined"
        className="mx-auto w-fit"
      >
        <DoubleCheckIcon />
        {t('finish-recruitment')}
      </Button>
    </Column>
  );
}
